var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "./styles.scss";
import { CollectionRoot as Root } from "@react-components/primitives/Collection/CollectionRoot/CollectionRoot";
import { CollectionEntries as Entries } from "@react-components/primitives/Collection/CollectionEntries/CollectionEntries";
import { CollectionLoadMore as LoadMore } from "@react-components/primitives/Collection/CollectionPagination/CollectionLoadMore/CollectionLoadMore";
import { CollectionFilters as Filters } from "@react-components/primitives/Collection/CollectionFilters/CollectionFilters";
import { CardRenderer } from "@react-components/ui/Cards/CardRenderer";
import { DotLoader } from "@react-components/ui/Loaders/DotLoader/DotLoader";
import { getCardTypeByAlias } from "@react-components/ui/Cards/getCardTypeByAlias";
import { generateColumns, } from "@react-common/helpers/generate-columns";
import { useDictionaryContext } from "@contexts/dictionary-context/useDictionaryContext";
var CollectionRoot = function (_a) {
    var _b;
    var children = _a.children, columnSizes = _a.columnSizes;
    return (_jsx(Root, { children: _jsx("div", { className: "collection container", children: _jsx("div", { className: "row justify-content-center", children: _jsx("div", { className: "col-12", children: _jsx("div", { className: "collection__bg", children: _jsx("div", { className: "row justify-content-center", children: _jsx("div", { className: "".concat((_b = generateColumns(columnSizes)) !== null && _b !== void 0 ? _b : "col-11 col-md-10", " collection__column"), children: _jsx("div", { className: "collection__container", children: children }) }) }) }) }) }) }) }));
};
var CollectionEntries = function (_a) {
    var defaultCardType = _a.defaultCardType, collection = _a.collection, showLoader = _a.showLoader, renderEntry = _a.renderEntry, columnSizes = _a.columnSizes, totalCollectionSize = _a.totalCollectionSize, HeaderComponent = _a.renderEntryHeader, otherProps = __rest(_a, ["defaultCardType", "collection", "showLoader", "renderEntry", "columnSizes", "totalCollectionSize", "renderEntryHeader"]);
    var dictionary = useDictionaryContext().dictionary;
    return (_jsxs("div", { className: "row", children: [_jsx("div", { className: "col-12", children: _jsx("div", { className: "collection__total", children: HeaderComponent ? (_jsx(HeaderComponent, {})) : (_jsxs(_Fragment, { children: [totalCollectionSize, " ", dictionary.totalResultsCount] })) }) }), showLoader ? (_jsx("div", { className: "col-12", children: _jsx("div", { className: "row justify-content-center", children: _jsx(DotLoader, { size: 12 }) }) })) : (_jsx(Entries, __assign({ collection: collection !== null && collection !== void 0 ? collection : [], renderEntry: function (entry) {
                    var _a;
                    return (_jsx("div", { className: "".concat((_a = generateColumns(columnSizes)) !== null && _a !== void 0 ? _a : "col-12 col-md-6 col-lg-4", " collection__entry-wrap"), children: renderEntry ? (renderEntry(entry)) : (_jsx(CardRenderer, { componentType: defaultCardType !== null && defaultCardType !== void 0 ? defaultCardType : getCardTypeByAlias(entry), imageWidth: [
                                576,
                                250,
                                null,
                                null,
                                308,
                                367,
                            ], imageHeight: [
                                195,
                                195,
                                null,
                                null,
                                195,
                                195,
                            ], useRatio: true, props: entry })) }));
                } }, otherProps)))] }));
};
var CollectionFilters = function (_a) {
    var children = _a.children;
    return (_jsx(Filters, { children: _jsx("div", { className: "filters", children: _jsx("div", { className: "filters__row", children: React.Children.map(children, function (child) {
                    return React.isValidElement(child) && (_jsx("div", { className: "filters__col", children: child }));
                }) }) }) }));
};
var CollectionLoadMore = function (_a) {
    var isValidating = _a.isValidating, children = _a.children, otherProps = __rest(_a, ["isValidating", "children"]);
    return (_jsx("div", { className: "collection__button-wrap", children: _jsxs(LoadMore, __assign({}, otherProps, { children: [children, isValidating && (_jsx("div", { className: "ml-2", children: _jsx(DotLoader, {}) }))] })) }));
};
export { CollectionRoot, CollectionEntries, CollectionLoadMore, CollectionFilters, };
